import {
  AfterViewInit,
  Component,
  computed,
  DOCUMENT,
  Inject,
  inject,
} from '@angular/core';

import { environment } from '@eai-tdv/environment';

import { AppMenuService } from '@eai-tdv/core/services/app-menu';

import { AppVersionWatchService } from './core/components/app-version-watch/app-version-watch.service';
import {
  AppVersionService,
  AuthUserStateService,
  EnvironmentService,
  NetworkStatusService,
  PlatformOptionsService,
  SubscriptionsService,
} from './core/services';
import { AppTrapFocusService } from './core/services/app-trap-focus.service';
import { ToastStackHostService } from './shared/components/toast';
@Component({
  // must be app-root (for future BE side rendering).
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements AfterViewInit {
  appVersion = AppVersionService.version;
  private networkStatusS = inject(NetworkStatusService);
  private toastStackHostS = inject(ToastStackHostService);
  public readonly showIntercomeSgnl = computed(() => {
    const isUserAuthenticated = !!this.authUserStateS.authProfileSgnl();
    const isAvailableForEnv = !!environment.intercom.appId;
    if (EnvironmentService.isProd) {
      return isAvailableForEnv && isUserAuthenticated;
    } else {
      return isAvailableForEnv;
    }
  });

  public readonly showVersionAvailablePopupSgnl = computed(() => {
    const isUserAuthenticated = !!this.authUserStateS.authProfileSgnl();
    return isUserAuthenticated && this.appVersionWatchS.showVersionPopupSgnl();
  });

  constructor(
    public appMenuS: AppMenuService,
    public authUserStateS: AuthUserStateService,
    public appTrapFocusS: AppTrapFocusService,
    public subscriptionsS: SubscriptionsService,
    @Inject(DOCUMENT) private document: Document,
    private readonly appVersionWatchS: AppVersionWatchService,
  ) {
    PlatformOptionsService.init();
    this.toastStackHostS.init();
    this.networkStatusS.init();
  }

  ngAfterViewInit(): void {
    this.appVersionWatchS.startWatchUpdates();
    // don't remove this  code because it will be need very often for test cases with Tab and Tab+Shift on localhost development
    if (!environment.production && EnvironmentService.isLocal) {
      this.document.body.classList.add('tdv-development-localhost');
    }
  }

  public showMenuSgnl = computed(() => {
    const show =
      this.appMenuS.forceShowMenuSgnl() ||
      (this.appMenuS.isOpenSgnl() &&
        (EnvironmentService.disablePhoneVerification
          ? true
          : this.authUserStateS.authProfileSgnl()?.phone_verified) &&
        this.subscriptionsS.subscriptionExistingStatusSgnl() === 'exist');
    return show;
  });
}
